import { useMemo } from "react";

export const fmtDuration = (m) => {
  if (!m) return "0 min";
  const h = Math.floor(m / 60);
  const r = m % 60;
  if (!h) return `${r} min`;
  return r ? `${h} h ${r} min` : `${h} h`;
};

export const fmtDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" });

// 0–24-Uhr-Zeitleiste mit den Arbeitsblöcken eines Tages.
export function DayTimeline({ blocks, testid }) {
  const hours = useMemo(() => [0, 6, 12, 18, 24], []);
  return (
    <div className="relative" data-testid={testid}>
      <div className="relative h-6 rounded-md bg-zinc-900 border border-zinc-800 overflow-hidden">
        {blocks.map((b, i) => (
          <div key={i} title={`${b.start}–${b.end} · ${fmtDuration(b.duration_minutes)}`}
               className="absolute top-0 bottom-0 bg-[#00E575]/70 border-x border-[#00E575]"
               style={{ left: `${(b.start_min / 1440) * 100}%`, width: `${Math.max(0.4, ((b.end_min - b.start_min) / 1440) * 100)}%` }} />
        ))}
      </div>
      <div className="flex justify-between text-[10px] text-zinc-500 font-mono mt-0.5">
        {hours.map((h) => <span key={h}>{String(h).padStart(2, "0")}</span>)}
      </div>
    </div>
  );
}

export function DayDetail({ day, uid }) {
  return (
    <div className="rounded-xl border border-zinc-800 bg-[#121215] p-3 space-y-2" data-testid={`activity-day-${uid}-${day.date}`}>
      <div className="flex items-baseline justify-between gap-2 flex-wrap">
        <div className="text-[13px] font-semibold text-zinc-100">{fmtDate(day.date)}</div>
        <div className="text-[12px] text-zinc-400">
          {day.first_start}–{day.last_end} · <b className="text-[#00E575]">{fmtDuration(day.work_minutes)}</b>
        </div>
      </div>
      <DayTimeline blocks={day.blocks} testid={`activity-timeline-${uid}-${day.date}`} />
      <div className="flex flex-wrap gap-1.5">
        {day.blocks.map((b, i) => (
          <span key={i} className="text-[11.5px] font-mono px-2 py-0.5 rounded-md bg-zinc-800 text-zinc-200"
                data-testid={`activity-block-${uid}-${day.date}-${i}`}>
            {b.start}–{b.end} <span className="text-zinc-500">({fmtDuration(b.duration_minutes)})</span>
          </span>
        ))}
      </div>
    </div>
  );
}
